// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:aCfYA4 */\n.lq9c-{grid-gap:var(--audio-spacing-16);display:grid;gap:var(--audio-spacing-16);grid-template-columns:1fr}._9Jeqz{font-size:var(--audio-font-size-16);font-weight:600;letter-spacing:.05em;margin:0;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "lq9c-",
	"title": "_9Jeqz"
};
export default ___CSS_LOADER_EXPORT___;
